import { render, staticRenderFns } from "./CardItensPedidoInsumos.vue?vue&type=template&id=b867e936&"
import script from "./CardItensPedidoInsumos.vue?vue&type=script&lang=js&"
export * from "./CardItensPedidoInsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports